import React from "react";
import { CellProps } from "react-table";
import { InspectionStatus } from "../constants/InspectionStatus";
import { InspectionData } from "../constants/CitizenInspection";
import InspectionStatusLabel from "../../InspectionStatusLabel";

export default function InspectionStatusCell({ cellProps }: { cellProps: CellProps<InspectionData> }) {
  const status = cellProps.row.original.status as InspectionStatus;
  return <InspectionStatusLabel status={status} />;
}
